import { AxiosInstance, AxiosStatic } from 'axios';

export interface CdnJsonClient {
  get<T>(url: string): Promise<T>;
}

export class HttpCdnJsonClient implements CdnJsonClient {
  private readonly axios: AxiosInstance;

  constructor({ axiosStatic }: { axiosStatic: AxiosStatic }) {
    this.axios = axiosStatic.create();
  }

  public async get<T>(url: string): Promise<T> {
    const response = await this.axios.get<T>(url);
    return response.data;
  }
}
